import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import {
  fetchLeads,
  leadMatchesBranch,
  leadMatchesPerson,
  needsSalesperson,
  wasContacted,
} from "../../../views/WebleadsV3/utilities";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Branch + personal counts from the active web-lead queue, mirroring the
// stat tiles on the Web Lead Manager page.
const WebLeadsWidget = () => {
  const user = useSelector(selectUser);
  const [counts, setCounts] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.branch) return;
    let cancelled = false;
    fetchLeads("Active", user.branch)
      .then((leads) => {
        if (cancelled) return;
        const active = (Array.isArray(leads) ? leads : []).filter((lead) =>
          leadMatchesBranch(lead, user.branch)
        );
        setCounts({
          awaiting: active.filter((lead) => !wasContacted(lead)).length,
          needsSales: active.filter(needsSalesperson).length,
          mine: active.filter((lead) => leadMatchesPerson(lead, user.userID))
            .length,
        });
      })
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, [user?.branch, user?.userID]);

  return (
    <WidgetFrame title="Web Leads" to="/webleads">
      {counts ? (
        <div className="grid grid-cols-3 gap-2">
          <WidgetStat value={counts.awaiting} label="Awaiting contact" />
          <WidgetStat value={counts.needsSales} label="Need salesperson" />
          <WidgetStat value={counts.mine} label="My active" />
        </div>
      ) : (
        <WidgetEmpty>
          {failed ? "Couldn't load web leads." : "Loading web leads…"}
        </WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default WebLeadsWidget;
